import { FormGroup } from '@angular/forms';
import { ApplianceDetailsForm } from './appliance-details-form.interface';

export type ApplianceDetailsFormValue = ReturnType<
  FormGroup<ApplianceDetailsForm>['getRawValue']
>;
